/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { shape, bool, string } from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'clsx';

import { createUrl } from 'utils/urlHelper';

import Avatar from 'components/Avatar/Avatar';
import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './message-card.scss';

/**
 * This is the MessageCard component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class MessageCard extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: shape({
      is_talent: bool,
      is_client: bool,
    }).isRequired,
    currentDiscussionId: string,
    discussion_id: string.isRequired,
    discussion_type: string,
    company_name: string.isRequired,
    talent_fullname: string.isRequired,
    talent_title: string.isRequired,
    has_new_content: bool.isRequired,
    is_chat_active: bool.isRequired,
    customPath: string,
    job_title: string.isRequired,
    hired: bool,
    closed: bool,
  };

  static defaultProps = {
    currentDiscussionId: null,
    discussion_type: null,
    customPath: null,
    hired: false,
    closed: false,
  };

  /**
   * Render MessageCard.
   *
   * @return {Object}
   */
  render() {
    const {
      user: { is_talent },
      currentDiscussionId,
      talent_fullname,
      talent_title,
      talent_picture,
      company_name,
      job_picture,
      has_new_content,
      is_chat_active,
      discussion_id,
      discussion_type,
      customPath,
      job_title,
      hired,
      closed,
    } = this.props;

    // const isSupport = discussion_type === 'SUPPORT';
    const isShortlist = discussion_type === 'SHORTLIST';
    const isArchived = !isShortlist && !is_chat_active;

    const messageUrl = customPath || createUrl('message', discussion_id);

    const avatar_url = is_talent ? job_picture : talent_picture;
    const name = is_talent ? company_name : talent_fullname;
    const title = is_talent ? company_name : `${name} · ${talent_title}`;

    return (
      <Link
        to={messageUrl}
        className={classNames(styles.wrapper, {
          [styles.new]: has_new_content,
          [styles.archived]: isArchived,
          [styles.active]: currentDiscussionId === discussion_id,
        })}
      >
        <div className={styles.avatarWrapper}>
          <Avatar src={avatar_url?.square_url}>{name}</Avatar>
          {(closed || hired) && (
            <BlackTieIcon
              className={classNames(styles.closed, styles.badge, {
                [styles.closed]: closed,
                [styles.hired]: hired,
              })}
              icon={closed ? 'times-circle' : 'check-circle'}
            />
          )}
        </div>
        <div className={styles.container}>
          <p className={classNames(styles.job)}>{job_title}</p>
          <p className={classNames(styles.to)}>{title}</p>
        </div>
      </Link>
    );
  }
}

export default MessageCard;
